import { render, staticRenderFns } from "./MyProfile.vue?vue&type=template&id=1200c44a&scoped=true&lang=pug&"
import script from "./MyProfile.vue?vue&type=script&lang=ts&"
export * from "./MyProfile.vue?vue&type=script&lang=ts&"
import style0 from "./MyProfile.vue?vue&type=style&index=0&id=1200c44a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1200c44a",
  null
  
)

export default component.exports